<template>
  <div class="wrapper">
    <div class="new-main-footer-revamp">
      <!-- DESKTOP -->
      <div
        v-if="!isMobileSize"
        class="new-main-footer-revamp__item"
      >
        <SocialMedia />
        <OurServices />
        <PromoTips />
        <OtherInfo />
        <ContactUs />
        <DownloadApp />
      </div>
      <!-- END DESKTOP -->

      <!-- MOBILE -->
      <div
        v-if="isMobileSize"
        class="new-main-footer-revamp__item"
      >
        <SocialMedia />
        <div class="mobile-site-link">
          <OurServices />
          <div class="mobile-site-link-stack">
            <PromoTips />
            <OtherInfo />
          </div>
        </div>
        <div class="mobile-site-contact">
          <ContactUs />
          <DownloadApp v-if="isMobileSize" />
        </div>
      </div>
      <!-- END MOBILE -->
    </div>

    <div class="end-footer-revamp">
      <hr>
      <div class="end-footer-revamp__inside">
        @ {{ yearNow }} All Rights Reserved - Lion Parcel
      </div>
    </div>
  </div>
</template>

<script>
import SocialMedia from "./SocialMedia";
import OurServices from "./OurServices";
import PromoTips from "./PromoTips";
import OtherInfo from "./OtherInfo";
import ContactUs from "./ContactUs";
import DownloadApp from "./DownloadApp";
import mixinMobile from "@/misc/mixinMobile";

export default {
  name: "Footer",
  components: {
    SocialMedia,
    OurServices,
    PromoTips,
    OtherInfo,
    ContactUs,
    DownloadApp,
},
  mixins: [mixinMobile],
  data() {
    return {
      yearNow: new Date().getFullYear(),
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./style";

.mobile-site-link {
  display: flex;
}

.mobile-site-link-stack {
  margin-bottom: -15px;
}

.mobile-site-contact {
  display: block;
}

.wrapper {
  width: 100%;
  max-width: 1360px;
  padding: 20px 60px;
  justify-content: space-between;

  @include for-size(mobile) {
    width: 85%;
    padding: unset;
  }

  @include for-size(mobile-landscape) {
    width: 85%;
    padding: unset;
  }

  @include for-size(tablet-portrait) {
    width: 85%;
    padding: unset;
  }

  @media (min-width: 1024px) and (max-width: 1280px) {
    width: 85%;
    padding: unset;
  }
}
</style>
